import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Home, Search } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div style={{ minHeight: "80vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 24px", textAlign: "center" }}>
      <div style={{ fontFamily: "var(--font-head)", fontSize: 120, fontWeight: 800, color: "var(--border)", lineHeight: 1, marginBottom: 0 }}>404</div>
      <div style={{ fontSize: 48, marginBottom: 16 }}>😅</div>
      <h1 style={{ fontFamily: "var(--font-head)", fontSize: 28, fontWeight: 700, marginBottom: 12 }}>Page Not Found</h1>
      <p style={{ color: "var(--text-muted)", fontSize: 16, maxWidth: 400, lineHeight: 1.7, marginBottom: 36 }}>
        Looks like this page doesn't exist or has been moved. Let's get you back on track.
      </p>
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", justifyContent: "center" }}>
        <Link to="/" className="btn btn-primary btn-lg"><Home size={18} /> Go Home</Link>
        <Link to="/shop" className="btn btn-secondary btn-lg"><Search size={18} /> Browse Shop</Link>
      </div>
    </div>
  );
}
